// extracted by mini-css-extract-plugin
export default {"root":"RequestDemo_root__PPpEt","link":"RequestDemo_link__h+T6K"};